import { render } from "./ScrollPane.vue?vue&type=template&id=3181dff8&scoped=true&ts=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=3181dff8&lang=scss&scoped=true"
import "./ScrollPane.vue?vue&type=style&index=1&id=3181dff8&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181dff8"]])

export default __exports__